import { combineReducers } from 'redux';
import AppReducer from './AppReducer';
import  LocaleReducer from './LocaleReducer';
import  ToastReducer from './ToastReducer';
import  AuthReducer from './AuthReducer';
import UserInfoReducer from './UserInfoReducer';
import { reducer as formReducer} from 'redux-form'
import SecurePaymentReducer from './SecurePaymentReducer'

export default combineReducers({
    AppReducer,
    LocaleReducer,
    ToastReducer,
    AuthReducer,
    UserInfoReducer,
    form : formReducer,
    SecurePaymentReducer
});
